import { render, staticRenderFns } from "./seed-card.vue?vue&type=template&id=789a798f&scoped=true"
import script from "./seed-card.vue?vue&type=script&lang=js"
export * from "./seed-card.vue?vue&type=script&lang=js"
import style0 from "./seed-card.vue?vue&type=style&index=0&id=789a798f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a798f",
  null
  
)

export default component.exports